import styled, { x } from '@xstyled/styled-components';
import React, { FC } from 'react';
import { Button } from '~/ui/buttons/Button';
import { Flex } from '~/ui/flex/Flex';
import { LlamaModal } from '~/ui/llama-modal/LlamaModal';

/**
 * The card the pretest entry, results and messages sit on, like the onboarding cards. Entry and results
 * carry more text, so they use the wide card; it fills the screen on phones.
 */
export const PretestScreen: FC<{ wide?: boolean }> = ({ children, wide }) => (
  <>
    <x.div w="100%" h="100%" bg="var(--color-accent-lt)" />
    <LlamaModal horizontal="center" vertical="center" allowScroll>
      <Flex
        w={wide ? { _: '100%', sm: 'xl' } : 'md'}
        maxW="100%"
        minHeight="md"
        flexDirection="column"
        p={wide ? { _: 'lg', sm: 'xl' } : 'xl'}
        gap="md"
        justifyContent="space-between"
        data-test-id="pretest-screen"
      >
        {children}
      </Flex>
    </LlamaModal>
  </>
);

/** The quiet way out next to a primary action, as in onboarding. */
export const TextButton = styled.button`
  display: inline-block;
  width: fit-content;
  max-width: 100%;
  min-height: 44px;
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  color: var(--color-accent-fg);
  cursor: pointer;
  border: none;
  background: none;
  padding: 2px 4px;
  font-family: inherit;

  &:hover:not(:disabled) {
    text-decoration: underline;
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }

  &:focus-visible {
    outline: 2px solid var(--color-focus-ring);
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

/** Assessment actions can contain long translated labels inside a narrow card. */
export const PretestButton = styled(Button)`
  min-width: 0;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
  text-decoration: none;
`;

/** A full-width alternative to the primary action, quieter than it but clearly enabled. */
export const SecondaryButton = styled(PretestButton)`
  background-color: var(--color-white);
  color: var(--color-black);
  border: 1px solid var(--color-grey-md);

  &:hover:not(:disabled) {
    background-color: var(--color-grey-lt);
  }

  &:active:not(:disabled) {
    background-color: var(--color-grey-md);
  }
`;
